import PlanningSection from './PlanningSection';
import PlanningStepper from './PlanningStepper';
import { PLANNING_PHASES } from './USCGPage';
import { useIncident, useIncidentPermissions } from '../hooks/incidentHooks';
import { CurrentIAPView } from './CurrentIAPView';
import { IAP_DASHBOARD_MODES } from '../ICSConstants';
import { useRef } from 'react';
import classNames from 'classnames';
import { CorporateViewTabGroup } from 'components/MapPage/CorporateViewTabGroup';
import { UscgMapLayout } from 'components/MapPage/UscgMapLayout';
import { useUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/UscgMapContext';

const PlanningDashboard = ({
  updatePhase,
  updateMode,
  currentPhase,
  currentMode,
}: {
  updatePhase: (phase: number) => void;
  updateMode: (isFutureMode: string) => void;
  currentPhase: number;
  currentMode: string;
}) => {
  const { isMapVisible } = useUscgMapContext();

  const { data: incidentPermissions } = useIncidentPermissions();

  const canViewFuturePeriod =
    incidentPermissions?.['incident:viewFuturePeriod'] ?? false;

  const isFutureMode =
    currentMode === IAP_DASHBOARD_MODES.FUTURE && canViewFuturePeriod;
  const mainContentRef = useRef<HTMLDivElement>(null);
  // TODO TN eventually the planning phases should probably be some kind of object with different phases for different customers, and this will need to be changed
  const safeCurrentPhase = Math.min(currentPhase, PLANNING_PHASES.length - 1);
  const incident = useIncident();

  const mainContentClasses = classNames('maincontent iap-response__main', {
    'maincontent-no-padding': isMapVisible,
  });

  if (incident.data === undefined) {
    // NOTE: Don't return in the middle of render function. makes hooks unhappy
    return null;
  }

  return (
    <div className="iap-layout">
      {isMapVisible ? (
        <div className={mainContentClasses} ref={mainContentRef}>
          <UscgMapLayout>
            <CorporateViewTabGroup
              ics={true}
              currentMode={currentMode}
              updateMode={updateMode}
              currentPhase={currentPhase}
            />
          </UscgMapLayout>
        </div>
      ) : (
        <>
          {isFutureMode ? (
            <div className="d-flex flex-grow-1">
              <PlanningStepper
                planningPhases={PLANNING_PHASES}
                currentPhase={safeCurrentPhase}
                updatePhase={updatePhase}
              />
              <div className={mainContentClasses} ref={mainContentRef}>
                <div className="planning-container">
                  <PlanningSection
                    planningPhases={PLANNING_PHASES}
                    currentPhase={safeCurrentPhase}
                    updatePhase={updatePhase}
                    mainContentRef={mainContentRef}
                    key={safeCurrentPhase}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={mainContentClasses} ref={mainContentRef}>
              <CurrentIAPView />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PlanningDashboard;
